import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useFetchVesselImages = (vesselId) => {
  const { token } = useContext(AuthContext);

  const fetchVesselImages = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/vessel/images/${vesselId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status !== "success") {
        throw new Error(response.data.message || "Failed to fetch vessel images");
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  return useQuery(["vesselImages", vesselId], fetchVesselImages);
};

export default useFetchVesselImages;
